import Path from "../Path";
import PathPlanJumpUp from "../plan/PathPlanJumpUp";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJumpUp3 extends PathTemplatePattern {
    constructor() {
        super([
            'E',    // end
            '8',    // o|p
            '8',    // o|p
            'S'     // start
        ],
        false);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 3;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol();  // end tile is same column as the start
        const targetRow = start.getTileRow() - 3; // end tile is two rows higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUp(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol();  // end tile is same column as the start
        const targetRow = start.getTileRow() - 3; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUp(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJumpUp3';
    }
}